export default "__VITE_ASSET__DyvphRYu__"